import React, { useState } from 'react';
import './SearchBar.css'; // Import the CSS file for styling

const SearchBar = ({ onSearch }) => {
    const [query, setQuery] = useState('');

    const handleInputChange = (e) => {
        const value = e.target.value;
        setQuery(value);
        onSearch(value); // Trigger the search function
    };

    return (
        <div className="search-bar">
            <input
                type="text"
                className="search-input"
                placeholder="Search for products..."
                value={query}
                onChange={handleInputChange}
            />
            <button className="search-button" onClick={() => onSearch(query)}>
                🔍
            </button>
        </div>
    );
};

export default SearchBar;